import { Provider } from 'react-redux';
import { render } from 'react-dom';
import React from 'react';
import 'isomorphic-fetch';
import '@babel/polyfill';

import App from './components/app';
import store from './store';

const Root = ({ store }) => (
  <Provider store={store}>
    <App />
  </Provider>
);

render(<Root store={store} />, document.getElementById('fpls-external'));
